<template>
    <div class="col-md-12">
        <div class="container-fluid bg-light py-3">
            <div class="row">
                <div class="col-md-8">
                    <div class="h2">Plannings</div>
                </div>
                <div class="col md-4 d-flex align-items-right bg-white border rounded-lg div-focus border-2 calendar">
                    <!-- Button to shift date one day back -->
                    <button @click="shiftDate(-1)" class="arrow-button">
                        <i class="material-icons arrows">keyboard_arrow_left</i>
                    </button>
                    <date-picker
                        manual-input
                        v-model="filters.selectedDate"
                        valueType="format"
                        input-class="border-0 py-0 shadow-none form-input"
                        placeholder="yyyy-mm-dd"
                        :lang="datePickerOptions.lang"
                        format="YYYY-MM-DD"
                    >
                    </date-picker>
                    <!-- Button to shift date one day forward -->
                    <button @click="shiftDate(1)" class="arrow-button">
                        <i class="material-icons arrows">keyboard_arrow_right</i>
                    </button>
                </div>
                <div class="container-fluid bg-light py-3">
                    <div class="fixed-width-table">
                        <form @submit.prevent="updatePlanning">
                            <table class="table table-borderless planning-table">
                                <thead>
                                <tr>
                                    <th>Company</th>
                                    <th>Driver</th>
                                    <th>Vehicle</th>
                                    <th>Features</th>
                                    <th v-for="hour in hours"
                                        :key="hour"
                                        :class="{ 'vertical-line1': hour == 6, 'vertical-line2': hour == 16 }">
                                        {{ hour }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(planning,k) in plannings" :key="planning.id" v-if="planning.type===1">
                                    <td style="width:5%" class="align-middle">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="company-list"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="companyList"
                                                            required
                                                            v-model="plannings[k].company"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:30%;" class="align-middle">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div
                                                                class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                <div v-if="plannings[k].company.id===1">
                                                                    <v-select
                                                                        class="driver-list"
                                                                        :clearable="false"
                                                                        :clearSearchOnSelect="false"
                                                                        :options="driverList"
                                                                        required
                                                                        v-model="plannings[k].driver"
                                                                        label="name"
                                                                    >
                                                                    </v-select>
                                                                </div>
                                                                <div v-else>
                                                                    <v-select
                                                                        class="driver-list"
                                                                        :clearable="false"
                                                                        :clearSearchOnSelect="false"
                                                                        :options="driverListMultiple[plannings[k].company.id]"
                                                                        required
                                                                        v-model="plannings[k].driver"
                                                                        label="name"
                                                                    >
                                                                    </v-select>

                                                                    <!--                                                                <select class="form-control"-->
                                                                    <!--                                                                        v-model="plannings[k].driver.id">-->
                                                                    <!--                                                                    <option v-for="driver in drivers"-->
                                                                    <!--                                                                            v-if="plannings[k].company.id===driver.company_id"-->
                                                                    <!--                                                                            :value="driver.id"-->
                                                                    <!--                                                                            :key="driver.id">-->
                                                                    <!--                                                                        {{ driver.name }}-->
                                                                    <!--                                                                    </option>-->
                                                                    <!--                                                                </select>-->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6"
                                                             @click="showAdditionalDriverForPlanning(plannings[k].id)">
                                                            <div
                                                                v-if="plannings[k].additional_driver && plannings[k].company.id==1">
                                                                <div
                                                                    class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                    <v-select
                                                                        class="driver-list"
                                                                        :clearable="false"
                                                                        :clearSearchOnSelect="false"
                                                                        :options="driverList"
                                                                        required
                                                                        v-model="plannings[k].additional_driver"
                                                                        label="name"
                                                                    >
                                                                    </v-select>
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                <div
                                                                    class="material-icons-outlined icon-features text-primary plus-icon"
                                                                    v-if="showAdditionalDriverForPlannings.indexOf(plannings[k].id) === -1 && plannings[k].company.id===1">
                                                                    add
                                                                </div>
                                                                <div v-if="plannings[k].company.id==1">

                                                                    <div
                                                                        v-if="showAdditionalDriverForPlannings.indexOf(plannings[k].id) > -1"
                                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                        <div v-if="plannings[k].company.id===1">
                                                                            <v-select
                                                                                class="driver-list"
                                                                                :clearable="false"
                                                                                :clearSearchOnSelect="false"
                                                                                :options="driverList"
                                                                                required
                                                                                v-model="plannings[k].additional_driver"
                                                                                label="name"
                                                                            >
                                                                            </v-select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:5%" class="align-middle">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12 v-if=" v-if="plannings[k].company.id===1">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="vehicle"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="vehicleList"
                                                            required
                                                            v-model="plannings[k].vehicle"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:5%" class="align-middle">
                                        <div class="icon-checkbox-group">
                                            <div class="form-group row">
                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="plannings[k].feature_is_people_group"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="planning.feature_is_people_group == 1 ? 'checked' : 'unchecked'">group
                                                    </span>
                                                </label>

                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="plannings[k].feature_is_installation_needed"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="planning.feature_is_installation_needed == 1 ? 'checked' : 'unchecked'">construction
                                                    </span>
                                                </label>

                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="plannings[k].feature_is_frozen_products"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="planning.feature_is_frozen_products == 1 ? 'checked' : 'unchecked'">ac_unit
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                    <td colspan="24" style="width:55%" class="align-middle">
                                        <draggable v-model="plannings" :options="dragOptions">
                                            <div
                                                class="task"
                                                :style="{ width: plannings[k].width + 'px', left: plannings[k].left + 'px' }">
                                                <div
                                                    class="resize-handle-left"
                                                    @mousedown="startResize(plannings[k], 'left')">
                                                    &nbsp;
                                                    <span class="drag-title"> drag left </span>
                                                </div>
                                                <div
                                                    class="resize-handle-right"
                                                    @mousedown="startResize(plannings[k], 'right')">
                                                    &nbsp;
                                                    <span class="drag-title"> drag right </span>
                                                </div>
                                                <div :title="planning.name"
                                                     class="drag-handle"
                                                     @mousedown="startDrag(plannings[k])"></div>
                                                <span class="span-title"> {{ plannings[k].name }} </span>
                                            </div>
                                        </draggable>
                                    </td>
                                </tr>
                                <tr v-for="(data,k) in driverListInternalIntervals[filters.selectedDate]" :key="k">
                                    <td style="width:10%">
                                        <div
                                            class="align-items-center bg-white border rounded-lg div-focus border-2">
                                            <v-select
                                                class="company-list"
                                                :clearable="false"
                                                :clearSearchOnSelect="false"
                                                :options="companyList"
                                                required
                                                v-model="driverListInternalIntervals[filters.selectedDate][data.name].company_name"
                                                label="name"
                                            >
                                            </v-select>
                                        </div>
                                    </td>
                                    <td style="width:20%;">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="driver"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="driverList"
                                                            required
                                                            v-model="driverListInternalIntervals[filters.selectedDate][data.name].name"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="vehicle"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="vehicleList"
                                                            required
                                                            v-model="driverListInternalIntervals[filters.selectedDate][data.name].vehicle"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </td>
                                    <td style="width:10%">
                                        <div class="icon-checkbox-group">
                                            <div class="form-group row">
                                                <label class="checkbox-label">
                                                    <input
                                                        v-model="driverListInternalIntervals[filters.selectedDate][data.name].feature_is_people_group"
                                                        type="checkbox"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="driverListInternalIntervals[filters.selectedDate][data.name].feature_is_people_group == 1 ? 'checked' : 'unchecked'">group
                                                    </span>
                                                </label>

                                                <label class="checkbox-label">
                                                    <input
                                                        v-model="driverListInternalIntervals[filters.selectedDate][data.name].feature_is_installation_needed"
                                                        type="checkbox"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="driverListInternalIntervals[filters.selectedDate][data.name].feature_is_installation_needed == 1 ? 'checked' : 'unchecked'">construction
                                                    </span>
                                                </label>

                                                <label class="checkbox-label">
                                                    <input
                                                        v-model="driverListInternalIntervals[filters.selectedDate][data.name].feature_is_frozen_products"
                                                        type="checkbox"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="driverListInternalIntervals[filters.selectedDate][data.name].feature_is_frozen_products == 1 ? 'checked' : 'unchecked'">ac_unit
                                                    </span>
                                                </label>

                                            </div>
                                        </div>
                                    </td>
                                    <td colspan="24">
                                        <!--                                        {{ driverListInternalIntervals[filters.selectedDate][data.name].startHour }} -
                                                                                {{ driverListInternalIntervals[filters.selectedDate][data.name].endHour }}-->

                                        <div>
                                            <div
                                                class="task task-internal"
                                                :title="driverListInternalIntervals[filters.selectedDate][data.name].clients.join('/')"
                                                :style="{ width: driverListInternalIntervals[filters.selectedDate][data.name].width + 'px', left: driverListInternalIntervals[filters.selectedDate][data.name].left + 'px' }">
                                                <span class="span-title"
                                                      v-if="driverListInternalIntervals[filters.selectedDate][data.name].start!=='00:00:00' && driverListInternalIntervals[filters.selectedDate][data.name].end!=='00:00:00'">
                                                    {{
                                                        driverListInternalIntervals[filters.selectedDate][data.name].clients.join("/")
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-for="(planningEmpty, k) in planningEmptyRows">
                                    <td style="width:10%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="company-list"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="companyList"
                                                            required
                                                            v-model="planningEmptyRows[k].company"
                                                            @input="onChangePlanningEmptyRow"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:15%;">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div
                                                            class="col-md-6 align-items-center bg-white rounded-lg div-focus ">
                                                            <div v-if="planningEmptyRows[k].company.id===1">
                                                                <select class="form-control"
                                                                        v-model="planningEmptyRows[k].driver.id">
                                                                    <option v-for="driver in drivers"
                                                                            v-if="driver.type===1"
                                                                            :value="driver.id"
                                                                            :key="driver.id">
                                                                        {{ driver.name }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div v-else>
                                                                <select class="form-control"
                                                                        v-model="planningEmptyRows[k].driver.id">
                                                                    <option v-for="driver in drivers"
                                                                            v-if="planningEmptyRows[k].company.id===driver.company_id"
                                                                            :value="driver.id"
                                                                            :key="driver.id">
                                                                        {{ driver.name }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6"
                                                             @click="showAdditionalDriverForPlanning(planningEmptyRows[k].id)">
                                                            <div
                                                                v-if="planningEmptyRows[k].additional_driver && planningEmptyRows[k].company.id==1">
                                                                <select class="form-control"
                                                                        v-model="planningEmptyRows[k].additional_driver.id">
                                                                    <option v-for="driver in drivers"
                                                                            v-if="driver.type===1"
                                                                            :value="driver.id"
                                                                            :key="driver.id">
                                                                        {{ driver.name }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div v-else>
                                                                <div
                                                                    class="material-icons-outlined icon-features text-primary plus-icon"
                                                                    v-if="showAdditionalDriverForPlannings.indexOf(planningEmptyRows[k].id) === -1 && planningEmpty.company.id===1">
                                                                    add
                                                                </div>
                                                                <div v-if="planningEmptyRows[k].company.id==1">

                                                                    <div
                                                                        v-if="showAdditionalDriverForPlannings.indexOf(planningEmptyRows[k].id) > -1"
                                                                        class="align-items-center bg-white rounded-lg div-focus">


                                                                        <div v-if="planningEmptyRows[k].company.id===1">
                                                                            <select class="form-control"
                                                                                    v-model="planningEmptyRows[k].additional_driver">
                                                                                <option v-for="driver in drivers"
                                                                                        v-if="driver.type===1"
                                                                                        :value="driver.id"
                                                                                        :key="driver.id">
                                                                                    {{ driver.name }}
                                                                                </option>
                                                                            </select>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12 v-if=" v-if="planningEmptyRows[k].company.id===1">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="vehicle"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="vehicleList"
                                                            required
                                                            v-model="planningEmptyRows[k].vehicle"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div class="icon-checkbox-group">
                                            <div class="form-group row">
                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="planningEmptyRows[k].feature_is_people_group"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="planningEmptyRows[k].feature_is_people_group == 1 ? 'checked' : 'unchecked'">group
                                                    </span>
                                                </label>

                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="planningEmptyRows[k].feature_is_installation_needed"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="planningEmptyRows[k].feature_is_installation_needed == 1 ? 'checked' : 'unchecked'">construction
                                                    </span>
                                                </label>

                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="planningEmptyRows[k].feature_is_frozen_products"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="planningEmptyRows[k].feature_is_frozen_products == 1 ? 'checked' : 'unchecked'">ac_unit
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                    <td colspan="24"></td>
                                </tr>
                                <tr>
                                    <td style="height: 100px;">

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <button type="submit" class="btn btn-success"> Save changes</button>
                        </form>
                    </div>
                </div>
                <br/>
                <br/>

                <div class="container-fluid bg-light py-3">
                    <div class="fixed-width-table">

                        <form @submit.prevent="createPlanning">
                            <h5> Add manual entry</h5>
                            <table class="table table-borderless">
                                <tbody ref="manualEntry">
                                <tr>
                                    <td style="width:10%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="company-list"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="companyList"
                                                            required
                                                            v-model="newEntry.company"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:15%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div v-if="newEntry.company"
                                                         class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <div v-if="newEntry.company.id===1">
                                                            <select class="form-control"
                                                                    v-model="newEntry.driver">
                                                                <option v-for="driver in drivers"
                                                                        v-if="driver.type===1"
                                                                        :value="driver.id"
                                                                        :key="driver.id">
                                                                    {{ driver.name }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div v-else>
                                                            <select class="form-control"
                                                                    v-model="newEntry.driver">
                                                                <option v-for="driver in drivers"
                                                                        v-if="newEntry.company.id===driver.company_id"
                                                                        :value="driver.id"
                                                                        :key="driver.id">
                                                                    {{ driver.name }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div v-if="newEntry.company && newEntry.company.id===1"
                                                         class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <v-select
                                                            class="vehicle"
                                                            :clearable="false"
                                                            :clearSearchOnSelect="false"
                                                            :options="vehicleList"
                                                            required
                                                            v-model="newEntry.vehicle"
                                                            label="name"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div class="icon-checkbox-group">
                                            <div v-for="icon in icons" :key="icon" class="form-group row">
                                                <label class="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        v-model="selectedIcons[icon]"
                                                        class="icon-checkbox"
                                                    />
                                                    <span class="material-icons-outlined icon-features text-primary"
                                                          :class="iconClass(icon)">{{ icon }}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 calendar">
                                            <date-picker
                                                manual-input
                                                v-model="newEntry.startDate" valueType="format"
                                                input-class="border-0 py-0 shadow-none form-input"
                                                :lang="datePickerOptions.lang"
                                                placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                            </date-picker>
                                        </div>
                                    </td>
                                    <td style="width:5%">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 calendar">
                                            <date-picker
                                                manual-input
                                                v-model="newEntry.endDate" valueType="format"
                                                input-class="border-0 py-0 shadow-none form-input"
                                                :lang="datePickerOptions.lang"
                                                placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                            </date-picker>
                                        </div>
                                    </td>
                                    <td style="width:5%">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 calendar">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="Start time"
                                                v-model="newEntry.startTime"
                                                input-class="border-0 py-0 shadow-none form-input">
                                            </vue-timepicker>
                                            <span
                                                class="material-icons-outlined  pr-2 text-primary">schedule</span>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </td>
                                    <td style="width:5%">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 calendar">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="End time"
                                                v-model="newEntry.endTime"
                                                input-class="border-0 py-0 shadow-none form-input">
                                            </vue-timepicker>
                                            <span
                                                class="material-icons-outlined  pr-2 text-primary">schedule</span>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </td>
                                    <td style="width:10%">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                        <input type="text"
                                                               required
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="name"
                                                               autocomplete="none"
                                                               v-model="newEntry.name">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:20%">
                                        <button type="submit" class="btn btn-success manual-entry">+ Add manual entry
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import draggable from 'vuedraggable';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";

export default {
    name: "Planning",
    mixins: [datePickerOptionsMixin],
    components: {DatePicker, VueTimepicker, draggable},
    props: {
        driverTypeInternal: {type: Number, required: true},
    },
    data() {
        return {
            cellWidth: 10,
            dragOptions: {
                axis: 'x',
            },
            companyList: [],
            driverList: [],
            driverListMultiple: {},
            showAdditionalDriverForPlannings: [],
            driverListInternal: [],
            driverListInternalIntervals: [],
            vehicleList: [],
            company: {},
            driver: {},
            drivers: {},
            vehicle: {},
            newEntry: {},
            emptyEntry: {},
            icons: ["group", "construction", "ac_unit"],
            selectedIcons: {},
            plannings: [],
            planningEmptyRows: [
                {driver: {}, additional_driver: {}, company: {}, vehicle: {}},
            ],
            planningsInternal: {},
            filters: {selectedDate: this.getCurrentDate()},
            //hours: ["00", "02", "04", "06", "08", "10", "12", "14", "16", "18", "20", "22"],
            hours: Array.from({length: 24}, (_, index) => String(index).padStart(2, "0")),
        }
    },
    computed: {
        //
    },
    methods: {
        startDrag(task) {
            task.dragging = true;
            task.resizing = false;
            const originalLeft = task.left;
            const startX = event.clientX;

            const handleMouseMove = (e) => {
                const deltaX = e.clientX - startX;
                task.left = originalLeft + deltaX;
                if (task.left < 0) {
                    task.startHour = 1;
                    task.left = 0;
                    task.dragging = false;
                    return;
                }
            };

            const handleMouseUp = () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                task.dragging = false;

                // Update startHour and endHour based on the new position
                task.startHour = Math.round(task.left / this.cellWidth) + 1;
                task.endHour = Math.round((task.left + task.width) / this.cellWidth) + 1;
            };

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        },

        startResize(task, direction) {
            task.resizing = true;
            task.dragging = false;

            const originalLeft = task.left;
            const originalWidth = task.width;
            const startX = event.clientX;

            const handleMouseMove = (e) => {
                const deltaX = e.clientX - startX;
                if (direction === 'left') {
                    task.width = Math.max(originalWidth - deltaX, this.cellWidth * 2);
                    task.left = originalLeft + deltaX;
                    if (task.left < 0) {
                        task.startHour = 1;
                        task.left = 0;
                        task.resizing = false;
                        return;
                    }
                } else if (direction === 'right') {
                    task.width = Math.max(originalWidth + deltaX, this.cellWidth * 2);
                }
            };

            const handleMouseUp = () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                task.resizing = false;

                // Update startHour and endHour based on the new position and width
                task.startHour = Math.round(task.left / this.cellWidth) + 1;
                task.endHour = Math.round((task.left + task.width) / this.cellWidth) + 1;
            };

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        },
        showAdditionalDriverForPlanning(planningId) {
            if (this.showAdditionalDriverForPlannings.indexOf(planningId) === -1) {
                this.showAdditionalDriverForPlannings.push(planningId);
            }
        },
        fetchData() {
            axios.get('/plannings-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        const selectedDate = new Date(this.filters.selectedDate);
                        const startDate = new Date(value.start);
                        const endDate = new Date(value.end);
                        const startHour = startDate.getHours();
                        const endHour = endDate.getHours();
                        this.plannings.push({
                            id: value.id,
                            name: value.name,
                            type: value.type,
                            company: value.company,
                            driver: value.driver,
                            additional_driver: value.additional_driver,
                            vehicle: value.vehicle,
                            startHour: startHour,
                            endHour: endHour,
                            feature_is_people_group: value.feature_is_people_group,
                            feature_is_installation_needed: value.feature_is_installation_needed,
                            feature_is_frozen_products: value.feature_is_frozen_products,
                            left: startHour * 42,
                            width: (endHour - startHour) * 45,
                            resizing: false,
                            dragging: false,
                        });
                    });
                }).catch();

            axios.get('/companies-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.companyList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch();
            axios.get('/vehicles-list')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.vehicleList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch();
            this.getDriverList();
            this.getDriverListInternal();
            this.getDriverListInternalIntervals();
        },
        getDriverList() {
            this.driverList = [];
            this.driverListMultiple = {};
            axios.get(`/driver-list?type=${this.driverTypeInternal}`)
                .then(({data}) => {
                    this.drivers = data.data
                    Object.entries(data.data).forEach(entry => {
                            const [key, value] = entry;
                            if (value.type === 1) {
                                this.driverList.push({
                                    id: value.id,
                                    company_id: value.company_id,
                                    name: value.name,
                                });
                            }
                            if (!this.driverListMultiple[value.company_id]) {
                                this.driverListMultiple[value.company_id] = [];
                            }
                            this.driverListMultiple[value.company_id].push({
                                id: value.id,
                                company_id: value.company_id,
                                name: value.name,
                            });
                        }
                    );
                }).catch();
        },
        getDriverListInternal() {
            this.driverListInternal = [];
            axios.get('/get-current-internal-drivers')
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.driverListInternal.push({
                            id: value.driver,
                            name: value.driver,
                        });
                    });
                }).catch();
        },
        getDriverListInternalIntervals() {
            this.driverListInternalIntervals = [];
            axios.get('/get-current-internal-drivers-intervals')
                .then(({data}) => {
                    this.driverListInternalIntervals = data.data
                }).catch();
        },
        validateFormData() {
            const requiredFields = [
                "company",
                "driver",
                //"vehicle",
                "startDate",
                "endDate",
                "startTime",
                "endTime",
                "name",
            ];

            return requiredFields.every((field) => {
                return (
                    field in this.newEntry &&
                    (typeof this.newEntry[field] !== "undefined" ||
                        (typeof this.newEntry[field] === "object" &&
                            Object.keys(this.newEntry[field]).length > 0))
                );
            });
        },
        createPlanning() {
            if (this.validateFormData()) {
                this.newEntry.features = this.selectedIcons
                axios.post(`/planning/create`, this.newEntry).then((response) => {
                    window.location.reload();
                }).catch((error) => {
                })
            } else {
                alert("Please fill in all required fields before sending the data.");
            }
        },
        updatePlanning() {
            this.plannings.push({planningEmptyRows: this.planningEmptyRows})
            this.plannings.push({planningInternal: this.driverListInternalIntervals})
            console.log(this.plannings);
            axios.post(`/planning/update`, this.plannings).then((response) => {
                window.location.reload();
            }).catch((error) => {
            })
        },
        iconClass(icon) {
            return this.selectedIcons[icon] ? 'checked' : 'unchecked';
        },
        getCurrentDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        shiftDate(days) {
            const currentDate = new Date(this.filters.selectedDate);
            currentDate.setDate(currentDate.getDate() + days);
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            this.filters.selectedDate = `${year}-${month}-${day}`;
        },
        getTimeSlotClass(start, end, hour) {
            const selectedDate = new Date(this.filters.selectedDate);
            const startDate = new Date(start);
            const endDate = new Date(end);
            const startHour = startDate.getHours();
            const endHour = endDate.getHours();
            const isSingleDay = startDate.toDateString() === endDate.toDateString();

            selectedDate.setHours(hour, 0, 0, 0);

            if (selectedDate >= startDate && selectedDate <= endDate && (selectedDate.getDate() != endDate.getDate() || (hour >= startHour && hour <= endHour))) {
                if (selectedDate.getDate() == endDate.getDate() && hour > endHour) {
                    return "";
                } else {
                    return "red-slot";
                }
            }
            if (selectedDate.getDate() == endDate.getDate() && !isSingleDay) {
                if (hour <= endHour) {
                    return "red-slot";
                } else {
                    return "";
                }
            }
        },
        getTimeSlotClassInternal(start, end, hour) {
            const selectedDate = new Date(this.filters.selectedDate);
            const startTimeParts = start.split(":");
            const startHour = parseInt(startTimeParts[0], 10);

            const endTimeParts = end.split(":");
            const endHour = parseInt(endTimeParts[0], 10);

            if (hour >= startHour && hour <= endHour) {
                return "green-slot"
            } else {
                return "";
            }
        },
        fillClientName(start, end, word, isInternal) {
            const result = {};
            let startHour, endHour;

            if (isInternal === 1) {
                const startTimeParts = start.split(":");
                startHour = parseInt(startTimeParts[0], 10);

                const endTimeParts = end.split(":");
                endHour = parseInt(endTimeParts[0], 10);
            } else {
                const selectedDate = new Date(this.filters.selectedDate);
                const startDate = new Date(start);
                startHour = startDate.getHours() + 1;
                endHour = 24;
            }


            for (let i = startHour; i <= endHour; i++) {
                const letterIndex = i - startHour;
                if (letterIndex < word.length) {
                    result[i] = word.charAt(letterIndex);
                } else {
                    result[i] = '';
                }
            }

            return result
        },
        onChangePlanningEmptyRow() {
            const hasEmptyCompany = this.planningEmptyRows.some(
                (row) => Object.keys(row.company).length === 0
            );
            if (!hasEmptyCompany) {
                this.planningEmptyRows.push({
                    driver: {},
                    additional_driver: {},
                    company: {},
                    vehicle: {},
                });
            }
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>

<style scoped>
.red-slot {
    background-color: red;
    height: 100%;
    display: block;
    width: 100%;
    cursor: move;
    z-index: 1000;
}

.green-slot {
    background-color: green;
    height: 100%;
    display: block;
    width: 100%;
    cursor: move;
    z-index: 1000;
}

.calendar {
    position: relative;
    top: -7px;
}

.icon-checkbox-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    top: 5px
}

.checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.icon-checkbox {
    display: none; /* Hide the actual checkbox */
}

.material-icons-outlined.icon-features.text-primary.checked {
    color: #843468 !important;
}

.material-icons-outlined.icon-features.text-primary.unchecked {
    color: gray !important;
}

.arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
}

i.mx-icon-calendar {
    display: none !important;
}

.table-cell-no-padding {
    padding: 0 !important;
    margin: 0 !important;
    /*  border-left: none !important;
      border-right: none !important;*/
    /*    cursor:pointer;*/
}

.task {
    position: relative;
    top: -6px;
    height: 30px;
    background-color: red;
    color: white;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
}

.drag-handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: move;
}

.resize-handle-right {
    position: absolute;
    top: 0;
    right: -9px;
    width: 20px;
    height: 100%;
    background-color: red;
    cursor: ew-resize;
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-left: 1px solid transparent;
    border-radius: 10px;
}

.resize-handle-left {
    position: absolute;
    top: 0;
    left: -9px;
    width: 20px;
    height: 100%;
    background-color: red;
    cursor: ew-resize;
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-left: 1px solid transparent;
    border-radius: 10px;
}

.drag-title {
    color: #ffffff;
    opacity: 0;
}

.resize-internal-timeline {
    background-color: green;
}

.task-internal {
    background-color: green;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-radius: 10px;
    cursor: default;
}

.arrows {
    top: 4px;
    position: relative;
}

.planning-table {
    overflow: hidden;
}

.planning-table th.vertical-line1 {
    position: relative;
    /*z-index: 100;*/
}

hr {
    background-color: #000 !important;
    height: 1px;
}

/* Pseudo-element to create the vertical line */
.planning-table th.vertical-line1::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: -1500px;
    right: 0;
    width: 2px;
    background-color: #000;
}

.planning-table th.vertical-line2 {
    position: relative;
    /* z-index: 100;*/
}

.span-title {
    color: white;
    /*
        font-size: small;
    */
    font-weight: bold;
    z-index: 1;
}

/* Pseudo-element to create the vertical line */
.planning-table th.vertical-line2::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: -1500px;
    right: 0;
    width: 2px;
    background-color: #000;
}

.planning-table tr {
    border-bottom: 1px solid #bdbdbd;
}

.planning-table tr:last-child {
    border-bottom: none; /* Remove border for the last row */
}

.plus-icon {
    color: green !important;
    cursor: pointer;
    position: relative;
    top: 9px;
}

.table thead th {
    border-bottom: 1px solid #000 !important;
}

select {
    appearance: none;
}

.manual-entry {
    position: relative;
    top: -5px;
}


</style>
